import React, {useEffect} from "react";
import {
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import {BrowserRouter} from "~/apps/core/BrowserRouter";
import {AccessRequired} from "~/apps/core/ui/AccessRequired";
import {useApolloClient} from "@apollo/client";
import {ServiceInterview} from "~/customers-experience/ServiceInterview";
import {IndexPage} from "~/apps/packages/cargos/components/IndexPage";
import {DetailPage} from "~/apps/packages/cargos/components/DetailPage";


export const APP_NAME = "cargos";
export const APP_VERSION = "1.0.0";


const CargosHistoryApp = () => {
    const client = useApolloClient();

    // Invalidate apollo cache when leave service
    useEffect(() => () => {
        client.cache.evict({id: "ROOT_QUERY", fieldName: "cargoHistoryCargos"});
    }, []);

    return (
        <AccessRequired title="История грузов">
            <BrowserRouter basename="/apps/cargos">
                <ServiceInterview serviceID={APP_NAME} serviceVersion={APP_VERSION}>
                    <Switch>
                        <Route path="/:id" exact={true}>
                            <DetailPage/>
                        </Route>
                        <Route path="/" exact={true}>
                            <IndexPage/>
                        </Route>
                        <Route path="*">
                            <Redirect to="/"/>
                        </Route>
                    </Switch>
                </ServiceInterview>
            </BrowserRouter>
        </AccessRequired>
    );
}


export default CargosHistoryApp;
